import React, { useEffect } from 'react';
import { Dispatch, bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { getPoint, resetPoint } from '../../store/actions/point';
import { getPlace, resetPlace } from '../../store/actions/place';
import { navigateSpace } from '../../store/actions/app';
import { ActionVideoSpace } from '../../containers/xr/space';
import { RootState } from '../../types/data';
import { PLACE_LOADED } from '../../common/constants/gateway-events';
import GatewayService from '../../services/gateway-service';
import { Helmet } from 'react-helmet';

type ActionVideoRouteProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  RouteComponentProps<{ placeId: string; type: string }>;

const getType = (type: string) => {
  switch (type) {
    case 'w':
      return 'walk_through';
    case 'f':
      return 'fly_through';
    default:
      return type;
  }
};

const ActionVideoRoute = ({ place, match, resetPoint, resetPlace, getPlace, navigateSpace }: ActionVideoRouteProps) => {
  const { placeId, type } = match.params;

  useEffect(() => {
    if (placeId) {
      (async () => {
        // @ts-ignore
        const res = await (getPlace(placeId) as Promise<any>);
        if (!res.__HANDLED_ERROR__) {
          const data = res.payload.data.response.action_video;
          const video_urls = data[`${getType(type)}_video_urls`];

          navigateSpace({
            ...data,
            video_urls,
          });
        }
      })();
    }

    return () => {
      resetPlace();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [placeId]);

  useEffect(() => {
    if (place.loaded && place.data) {
      GatewayService.emit(PLACE_LOADED, place.data);
    }
  }, [place.loaded, place.data]);

  const pageTitle = place.data?.action_video?.navigation_bar_title;

  return (
    <>
      <Helmet>{pageTitle ? <title>{`${pageTitle} | 360 Stories`} </title> : null}</Helmet>
      <ActionVideoSpace />
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  place: state.place.current,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      getPlace,
      resetPlace,
      getPoint,
      resetPoint,
      navigateSpace,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ActionVideoRoute));
